/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import MoserObject from './MoserObject';
import MoserObjectUtils from './MoserObjectUtils';
import PropertySetter from './PropertySetter';
import SplitColumnTreatment from './SplitColumnTreatment';
import SplitDisplay from './SplitDisplay';
import InstanceType from './InstanceType';
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
//@import com/ibm/bi/platform/moser/common/utils/MoserObjectUtils (runtime) // updateShortcutSet
//@import com/ibm/bi/platform/moser/common/generated/metadata/PropertySetter (runtime) // updateSplitRef
//@import com/ibm/bi/platform/moser/common/generated/metadata/SplitColumnTreatment (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/SplitDisplay (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/InstanceType (runtime) // new

/**
 * <p>Java class for splitType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="splitType"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="columnTreatment" type="{}splitColumnTreatment"/&gt; &lt;element name="display" type="{}splitDisplay"/&gt; &lt;element name="folderLabel" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="ref" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="instanceType" type="{}instanceType" minOccurs="0"/&gt; &lt;element name="relationshipRef" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="item" type="{}itemType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class SplitType extends MoserObject{

	columnTreatment = null;

	display = null;

	folderLabel = null;

	ref = null;

	instanceType = null;

	relationshipRef = null;

	item = null;

	_referencedObject = null;



	/**
	 * Gets the value of the columnTreatment property.
	 * @return {SplitColumnTreatment} possible object is {@link SplitColumnTreatment}
	 */
	getColumnTreatment() {
		return this.columnTreatment;
	}

	/**
	 * Sets the value of the columnTreatment property.
	 * @param {SplitColumnTreatment} value allowed object is {@link SplitColumnTreatment}
	 */
	setColumnTreatment(value) {
		var oldValue = this.columnTreatment;
		this.columnTreatment = value;
		this._setAndNotify(208, oldValue, value, false, false);
		MoserObjectUtils.updateShortcutSet(this, 208, oldValue, value);
	}

	/**
	 * Gets the value of the display property.
	 * @return {SplitDisplay} possible object is {@link SplitDisplay}
	 */
	getDisplay() {
		return this.display;
	}

	/**
	 * Sets the value of the display property.
	 * @param {SplitDisplay} value allowed object is {@link SplitDisplay}
	 */
	setDisplay(value) {
		var oldValue = this.display;
		this.display = value;
		this._setAndNotify(209, oldValue, value, false, false);
		MoserObjectUtils.updateShortcutSet(this, 209, oldValue, value);
	}

	/**
	 * Gets the value of the folderLabel property.
	 * @return {String} possible object is {@link String}
	 */
	getFolderLabel() {
		return this.folderLabel;
	}

	/**
	 * Sets the value of the folderLabel property.
	 * @param {String} value allowed object is {@link String}
	 */
	setFolderLabel(value) {
		var oldValue = this.folderLabel;
		this.folderLabel = value;
		this._setAndNotify(210, oldValue, value, false, false);
		MoserObjectUtils.updateShortcutSet(this, 210, oldValue, value);
	}

	/**
	 * Gets the value of the ref property.
	 * @return {String} possible object is {@link String}
	 */
	getRef() {
		return this.ref;
	}

	/**
	 * Sets the value of the ref property.
	 * @param {String} value allowed object is {@link String}
	 */
	setRef(value) {
		var oldValue = this.ref;
		this.ref = value;
		this._setAndNotify(6, oldValue, value, false, false);
		this._referencedObject = null;
		PropertySetter._updateSplitRef(this, oldValue, value);
		MoserObjectUtils.updateShortcutSet(this, 6, oldValue, value);
	}

	/**
	 * Gets the value of the instanceType property.
	 * @return {InstanceType} possible object is {@link InstanceType}
	 */
	getInstanceType() {
		return this.instanceType;
	}

	/**
	 * Sets the value of the instanceType property.
	 * @param {InstanceType} value allowed object is {@link InstanceType}
	 */
	setInstanceType(value) {
		var oldValue = this.instanceType;
		this.instanceType = value;
		this._setAndNotify(9, oldValue, value, false, false);
		MoserObjectUtils.updateShortcutSet(this, 9, oldValue, value);
	}

	/**
	 * Gets the value of the relationshipRef property.
	 * @return {String} possible object is {@link String}
	 */
	getRelationshipRef() {
		return this.relationshipRef;
	}

	/**
	 * Sets the value of the relationshipRef property.
	 * @param {String} value allowed object is {@link String}
	 */
	setRelationshipRef(value) {
		var oldValue = this.relationshipRef;
		this.relationshipRef = value;
		this._setAndNotify(211, oldValue, value, false, false);
		MoserObjectUtils.updateShortcutSet(this, 211, oldValue, value);
	}

	/**
	 * Gets the value of the item property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the item property. <p> For example, to add a new item, do as follows: <pre> getItem().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ItemType}
	 */
	getItem() {
		if (!this.item) {
			this.item = [];
		}
		return this.item;
	}

	/**
	 * Gets the value of the <code>item</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>ItemType</code> elements, or <code>null</code> if not set
	 */
	basicGetItem() {
		return this.item;
	}

	/**
	 * Creates a new instance of <code>SplitType</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> SplitType</code> object from.
	 * @return {SplitType} an object of type <code>SplitType</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createSplitType();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addItemAt(position, item) {
		this._addAtAndNotify(this.getItem(), position, item, 11, true, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addItem(item) {
		this.addItemAt(this.getItem().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeItemAt(position) {
		this._removeAtAndNotify(this.getItem(), position, 11, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeItem(item) {
		var i = this.getItem().indexOf(item);
		if (i >= 0) {
			this.removeItemAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "SplitType";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, true, false, 208, "columnTreatment", SplitColumnTreatment));
		featureList.push(this.createFeature(false, true, false, 209, "display", SplitDisplay));
		featureList.push(this.createFeature(false, false, false, 210, "folderLabel", null));
		featureList.push(this.createFeature(false, false, false, 6, "ref", null));
		featureList.push(this.createFeature(false, true, false, 9, "instanceType", InstanceType));
		featureList.push(this.createFeature(false, false, false, 211, "relationshipRef", null));
		var clazz;
		if (factory) {
			clazz = factory.createItemType().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 11, "item", clazz));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 208:
			this.setColumnTreatment((value));
			break;
		case 209:
			this.setDisplay((value));
			break;
		case 210:
			this.setFolderLabel((value));
			break;
		case 6:
			this.setRef((value));
			break;
		case 9:
			this.setInstanceType((value));
			break;
		case 211:
			this.setRelationshipRef((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 11:
			this.item = (value);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 208:
			return this.getColumnTreatment();
		case 209:
			return this.getDisplay();
		case 210:
			return this.getFolderLabel();
		case 6:
			return this.getRef();
		case 9:
			return this.getInstanceType();
		case 211:
			return this.getRelationshipRef();
		case 11:
			return this.getItem();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 208:
			return this.getColumnTreatment();
		case 209:
			return this.getDisplay();
		case 210:
			return this.getFolderLabel();
		case 6:
			return this.getRef();
		case 9:
			return this.getInstanceType();
		case 211:
			return this.getRelationshipRef();
		case 11:
			return this.basicGetItem();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 11:
			this.addItemAt(position, (value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 11:
			this.addItem((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 11:
			this.removeItemAt(position);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 11:
			this.removeItem((item));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Set the resolved object based on reference.
	 * @param {MoserObject} referencedObject the referenced <code>MoserObject</code>
	 */
	setReferencedObject(referencedObject) {
		this._referencedObject = referencedObject;
	}

	/**
	 * Get the resolved object based on reference.
	 * @return {MoserObject} the referenced <code>MoserObject</code>
	 */
	getReferencedObject() {
		return this._referencedObject;
	}

	clone() {
		var cloned = (super.clone());
		cloned.setReferencedObject(this._referencedObject);
		return cloned;
	}
}


// WEBPACK FOOTER //
// ./src/generated/SplitType.js